import { render, staticRenderFns } from "./RepairInventoryDetailModal.vue?vue&type=template&id=2713dfd6"
import script from "./RepairInventoryDetailModal.vue?vue&type=script&lang=js"
export * from "./RepairInventoryDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports